import { render, staticRenderFns } from "./bidGroup.vue?vue&type=template&id=8c5ddaba&scoped=true&"
import script from "./bidGroup.vue?vue&type=script&lang=js&"
export * from "./bidGroup.vue?vue&type=script&lang=js&"
import style0 from "./bidGroup.vue?vue&type=style&index=0&id=8c5ddaba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5ddaba",
  null
  
)

export default component.exports